import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api, assetUrl } from "@/lib/api";
import { localizedSlug } from "@/lib/utils";
import { MaskWords } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function PortfolioIndex() {
  const { lang, t } = useLang();
  const P = t.portfolio;
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  const g = (p, k) => p[`${k}_${lang}`] || p[`${k}_ro`] || "";

  return (
    <div className="bg-paper text-ink min-h-screen">
      <section className="px-6 md:px-12 lg:px-20 pt-36 md:pt-48 pb-14 md:pb-20">
        <div className="eyebrow text-ink/50 mb-6">{P.label}</div>
        <MaskWords Tag="h1" text={P.title} className="display uppercase text-[15vw] md:text-[16vw] lg:text-[13vw] leading-[0.82] break-words" />
        <p className="mt-8 text-lg md:text-xl leading-[1.55] text-ink/70 max-w-2xl">{P.intro}</p>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-32 md:pb-44">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-x-10 md:gap-y-16">
          {(projects || []).map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.08}>
              <Link
                to={`/portfolio/${localizedSlug(p, lang)}`}
                data-testid={`project-link-${p.slug}`}
                data-cursor="link"
                className={`group block ${i % 2 === 1 ? "md:mt-20" : ""}`}
              >
                <div className="relative overflow-hidden aspect-[4/3] bg-ink/5">
                  {p.cover_image && (
                    <img src={assetUrl(p.cover_image)} alt={g(p, "title")} className="w-full h-full object-cover transition-transform duration-[1300ms] ease-out group-hover:scale-105" />
                  )}
                </div>
                <div className="flex items-start justify-between gap-4 pt-5">
                  <div>
                    <div className="eyebrow text-ink/45 mb-2">{g(p, "category")} · {p.year}</div>
                    <h2 className="font-display text-3xl md:text-4xl leading-none">{g(p, "title")}</h2>
                  </div>
                  <ArrowUpRight size={26} className="shrink-0 mt-1 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        {projects && projects.length === 0 && <div className="eyebrow text-ink/40 py-10">{P.empty}</div>}
      </section>
    </div>
  );
}
